export enum ArtistRelationshipEnum {
  CareerManager = 0,
  Marketing = 1,
  ComercialAgent = 2,
  Producer = 3,
  Investor = 4,
  Other = 5,
  ArtistMember = 6,
  Label = 7,
  Distributor = 8,
  PublishingCompany = 9,
}

export const artistRelationshipList = [
  {
    label: "Gestor(a) de Carreira",
    value: ArtistRelationshipEnum.CareerManager,
  },
  { label: "Marketing", value: ArtistRelationshipEnum.Marketing },
  { label: "Agente Comercial", value: ArtistRelationshipEnum.ComercialAgent },
  { label: "Produtor(a)", value: ArtistRelationshipEnum.Producer },
  { label: "Investidor(a)", value: ArtistRelationshipEnum.Investor },
  { label: "Outro", value: ArtistRelationshipEnum.Other },
  { label: "Artista/Integrante", value: ArtistRelationshipEnum.ArtistMember },
  { label: "Selo/Gravadora", value: ArtistRelationshipEnum.Label },
  { label: "Distribuidora", value: ArtistRelationshipEnum.Distributor },
  { label: "Editora", value: ArtistRelationshipEnum.PublishingCompany },
];
